import error from '@/i18n/es/error';
import colleges from '@/i18n/es/colleges';
import students from '@/i18n/es/students';
import reports from '@/i18n/es/reports';
import courses from '@/i18n/es/courses';
import districtAdmins from '@/i18n/es/districtAdmins';
import campusGroupAdmins from '@/i18n/es/campusGroupAdmins';
import directiveAdmins from '@/i18n/es/directiveAdmins';
import calendarTypes from '@/i18n/es/calendarTypes';
import conglomerates from '@/i18n/es/conglomerates';
import diagnostics from '@/i18n/es/diagnostics';
import demos from '@/i18n/es/demos';
import studentSatisfaction from '@/i18n/es/studentSatisfaction';
import surveys from '@/i18n/es/surveys';
import supportRequests from '@/i18n/es/supportRequests';
import classlink from '@/i18n/es/classlink';
import adminActionLogs from '@/i18n/es/adminActionLogs';

export default {
  hello: 'Hola',
  footer_cs_love: 'Con mucho ❤️ para el equipo de Éxito al Cliente',
  login: {
    title: 'Administrador de colegios',
    subtitle: 'Ingresa tu usuario y contraseña',
    user_input: 'Usuario',
    password_input: 'Contraseña',
    login_btn: 'Acceder',
    register_btn: 'Registrar',
    password_required: 'Contraseña requerida',
    email_required: 'El correo electrónico es requerido.',
    email_format_validation: 'Formato de correo electrónico incorrecto.',
    dont_have_account: '¿No tienes una cuenta?',
    register_link: 'Registrate aquí',
    login_button: 'Iniciar Sesión',
  },
  register: {
    title: 'Registro',
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Correo electrónico',
    password_input: 'Contraseña',
    repeat_password_input: 'Confirma tu contraseña',
    back: 'Atrás',
    password_not_match: 'Las contraseñas no coinciden',
    password_length: 'La contraseña debe tener al menos 8 caracteres',
    school_group: 'Selecciona el grupo de colegios',
  },
  layout: {
    colleges: 'Colegios',
    conglomerates: 'Conglomerados',
    students: '🎓 Estudiantes',
    teachers: '🧑‍🏫 Profesores',
    'district-admins': '👨‍💼 Administradores de Distrito',
    'campus-group-admins': '🏫 Administradores de Grupo de Sede',
    'directive-admins': 'Directivos',
    edition: 'Edición',
  },
  error,
  colleges,
  students,
  reports,
  courses,
  district_admins: districtAdmins,
  campus_group_admins: campusGroupAdmins,
  directive_admins: directiveAdmins,
  calendar_types: calendarTypes,
  conglomerates,
  diagnostics,
  demos,
  studentSatisfaction,
  surveys,
  supportRequests,
  classlink,
  adminActionLogs,
  teachers: {
    label: 'profesores',
    name: 'Nombre',
    create: 'Crear Nuevo Profesor',
    general_information: '✨ Información del Profesor ✨',
    all_teachers: '🧑‍🏫 Todos los profesores',
    impersonate_select_app: 'Selecciona la aplicación para impersonar',
    impersonate_teachers_app: 'App de Profesores',
    impersonate_teachers_app_desc: 'Acceder a la aplicación de profesores',
    impersonate_datasystem: 'DataSystem',
    impersonate_datasystem_desc: 'Acceder al panel de reportes y datos',
    courses_assigned: 'Cursos asignados',
    add_course: 'Agregar curso de este colegio',
    no_courses_assigned: 'Este docente no tiene cursos asignados.',
    no_courses_available: 'No hay cursos disponibles en este colegio para agregar.',
    course_new: 'nuevo',
    course_inactive: 'Inactivo',
    inactive_courses: 'Cursos inactivos (no se muestran en la app de docentes)',
    inactive_courses_count: '{count} curso inactivo | {count} cursos inactivos',
    undo: 'Deshacer',
    unsaved_changes: 'Hay cambios sin guardar',
    discard_changes: 'Descartar cambios',
    save_changes: 'Guardar cambios',
    leave_confirm: 'Si sales ahora se perderán los cambios que no guardaste.',
    save_summary_title: 'Confirmar cambios',
    save_summary_intro: 'Vas a aplicar estos cambios en los cursos del docente:',
    summary_add: 'Agregar',
    summary_remove: 'Quitar',
    remove_course_other_school: 'pertenece a otra sede — se eliminará la asignación',
    // Formulario de creación
    country: 'País',
    school: 'Colegio',
    course: 'Curso (opcional)',
    courses: 'Cursos (opcional)',
    firstname: 'Nombre',
    lastname: 'Apellido P',
    lastname2nd: 'Apellido M (opcional)',
    email: 'Correo electrónico (opcional)',
    dni: 'DNI (opcional)',
    birth_date: 'Fecha de Nacimiento (opcional)',
    created_title: 'Docente creado',
    created_credentials: 'Usuario: {username} · Contraseña inicial: {password}',
    created_must_change: 'El docente deberá cambiar la contraseña en su primer ingreso.',
    created_no_email_notice:
      'Este docente no tiene correo. Comunícale su usuario y contraseña temporal. La recuperación de contraseña deberá realizarla el administrador.',
    create_another: 'Crear otro',
    create_error: 'No se pudo crear el docente. Inténtalo de nuevo.',
    email_exists: 'El correo o el usuario ya existe',
  },
  common: {
    all: 'Todos',
    filter: 'Filtros',
    filter_by: 'Filtrar por',
    to_disable: 'Deshabilitar',
    to_enable: 'Habilitar',
    student: 'Alumno',
    disable_message: 'Al realizar esta acción la cuenta quedará inhabilitada. ¿Estás seguro de querer realizar esta acción?',
    enable_message: 'Al realizar esta acción la cuenta quedará habilitada. ¿Estás seguro de querer realizar esta acción?',
    cancel: 'Cancelar',
    close: 'Cerrar',
    send: 'Enviar',
    to_save: 'Guardar',
    to_select: 'Seleccionar',
    to_transfer: 'Transferir',
    field_required: 'Este campo es requerido',
    an_error_ocurred: 'Ha ocurrido un error',
    support_text: 'Error inesperado en la aplicación.',
    support_desc: 'Por favor tome captura de este error y envie al equipo de tecnología.',
    save: 'Guardar',
    search: 'Buscar',
    clear_filter: 'Limpiar filtros',
    status: 'Estado',
    create: 'Crear',
    delete: 'Eliminar',
  },
  subscription: {
    overdue: 'Atrasada',
  },
  navigation: {
    colleges: '🚸 Colegios',
    conglomerates: '🏢 Conglomerados',
    students: '🎓 Estudiantes',
    teachers: '🧑‍🏫 Profesores',
    parents: '👩‍👧 Padres',
    reports: '📊 Reportes',
    district_admins: '🏛️ Admin Distritos',
    campus_group_admins: '🏫 Admin Grupos de Sede',
    directive_admins: 'Directivos',
    school_admin: 'Admin de Colegios',
    calendar_types: 'Tipos de calendario',
    diagnostics: '📝 Diagnósticos',
    users: '👥 Usuarios',
    demos: 'Demos',
    surveys: 'Encuestas',
    support_requests: '🎫 Bandeja de aprobación',
    integrations: '🔌 Integraciones',
    admin_action_logs: '🔎 Logs de administración',
  },
  users: {
    all_users: '👥 Todos los usuarios',
    user_type: 'Tipo de usuario',
    type_all: 'Todos',
    type_student: 'Estudiante',
    type_teacher: 'Profesor',
    type_directive: 'Directivo',
    type_district_admin: 'Admin Distrito',
    type_campus_group_admin: 'Admin Grupo Sede',
    type_school_group_admin: 'Admin Grupo Escolar',
    type_unknown: 'Desconocido',
    assignment: 'Asignación',
    impersonate: 'Impersonar',
    impersonate_opening: 'Abriendo sesión como',
    action_error: 'No se pudo completar la acción. Verifica que el usuario tenga ID o DNI.',
  },
  app_header: {
    school_administration: 'Administración de Colegios',
    user_administration: 'Administración de usuarios 👥',
  },
  general: {
    error_msg: 'Ha ocurrido un error. Por favor intertarlo nuevamente. Si el error persiste, pedir apoyo al equipo de soporte',
    loading: 'Cargando...',
    only_positive_number: 'Sólo ingresar números positivos, por favor',
    is_required: 'Este campo es requerido',
    valid_dates: 'Por favor ingresar fechas válidas',
    view: 'Ver',
    edit: 'Editar',
    cancel: 'Cancelar',
    actions: 'Acciones',
    itemsPerPage: 'Elementos por página',
  },
  version_update: {
    title: 'Hay una nueva versión disponible',
    text: 'Recarga la página para actualizar a la última versión.',
    button: 'Recargar',
  },
};
